import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getShopNameUseful } from '@api/login-page-claim';
import { setLoginLayout, setPlatform } from '@store'; // 这里调整引入路径
import {
  PLATFORM_REG, dhgate, PLATFORM_NAME,
} from '@constants/claim';
import { isBanVpnAccount } from '@/api';

export const useValidateUser = () => {
  const { pathname, search, host } = window.location || {};
  const [isValidUser, setIsValidUser] = useState(null); // 是否是有效用户
  const [loading, setLoading] = useState(true); // 用于前置判断用户接口状态
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // 校验店铺名对应的样式，目前针对2.0项目单独加多一个channel字段，优先匹配是否存在
  const validateUser = async ({ subDomain, channel }) => {
    console.log(subDomain);
    const { code, data } = await getShopNameUseful({
      subDomain,
      channel,
      pathname: 'get-rc-login-style',
    });

    if (code === 0 && !data?.isChannel) {
      dispatch(setLoginLayout({
        ...data,
        urlShopName: subDomain,
        isVisible: true,
        type: 'shopify',
      }));
      return {
        status: true,
      };
    }
    if (code === 0 && data?.isChannel) {
      dispatch(setLoginLayout({
        ...data,
        type: 'channel-shopify',
      }));
      return {
        status: false,
        isChannel: true, // 用于标记后端记录的渠道
      };
    }
    return {
      status: false,
    };
  };

  // 根据不同的platform 展示不同路径
  const oldUrlRedirect = (isChannel) => {
    // 提取子域或路径参数
    const subDomain = host.endsWith('.myshopify.com')
      ? host.replace('.myshopify.com', '')
      : pathname.split('/')[1];
    // 使用 includes 更直观
    let pathPlatform = (pathname?.match(PLATFORM_REG) || [])[0] || subDomain;
    // 判断是否需要走默认会首页逻辑
    let needDefault = true;
    // dhgate 完全定制化开发，特殊处理
    if (pathname.includes(dhgate)) {
      pathPlatform = dhgate;
    }
    if (pathname.includes(PLATFORM_NAME.SHOPPREMIUMOUTLETS)) {
      const path = pathname.replace(PLATFORM_NAME.SHOPPREMIUMOUTLETS, PLATFORM_NAME.NEWSPO);
      navigate(path + search);
      needDefault = false;
    }
    if (pathPlatform) {
      dispatch(setPlatform(pathPlatform));
      needDefault = false;
    }
    if (isChannel && needDefault) {
      // 如果是后端配置的渠道,但是前端没有配置，默认跳转到登录页
      navigate('/');
    }
  };

  const rcV4User = async () => {
    const { host, pathname, search } = window.location;
    // 提取子域或路径参数
    const subDomain = host.endsWith('.myshopify.com')
      ? host.replace('.myshopify.com', '')
      : pathname.split('/')[1];

    const params = new URLSearchParams(search);
    const seelPreviewCode = params.get('seelPreviewCode');
    const headers = seelPreviewCode ? {
      'seel-preview-code': seelPreviewCode,
    } : {};

    const data = await isBanVpnAccount({
      seelPreviewCode,
      headers,
    });
    // data = false，表示block，是vpn 访问
    if (!data) {
      navigate('/403');
    }

    if (subDomain) {
      try {
        const {
          status: isValid,
          isChannel, // 用于标记是否
        } = await validateUser({ subDomain, channel: subDomain });
        setIsValidUser(isValid);
        setLoading(false);
        return { isValid, isChannel };
      } catch (error) {
        setIsValidUser(false);
        setLoading(false);
        return false;
      }
    } else {
      setIsValidUser(false);
      setLoading(false);
      return false;
    }
  };

  return {
    isValidUser, loading, rcV4User, oldUrlRedirect,
  };
};
